export default "__VITE_ASSET__CyYTjnrm__"